/// <amd-module name="typeahead/features/CarRentalRequestParamModifier" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggestServiceParamModifier} from "typeahead/core/SuggestServiceParamModifier";

const featureFlags: string[] = ["cars_rental", "carsclickpopularity"];
const maxResults: number = 8;
const sortCriteria: string = "popularity";

export class CarRentalRequestParamModifier extends SuggestServiceParamModifier {
    protected configuration: IStripingConfiguration[] = [{
        lobs: ["CARS"],
    }];
    protected featureName: string;

    protected modify(params: ISuggestServiceQueryParams, context: IContext, options: any) {
        params.maxresults = maxResults;
        params.sortcriteria = sortCriteria;
        params.features = params.features && params.features.length ? params.features : [];
        Array.prototype.push.apply(params.features, featureFlags);
    }
}
